// Actions
const CARGAR_CONTENIDO = 'CARGAR_CONTENIDO';

export function cargarContenido(option) {
    return {
      type: CARGAR_CONTENIDO,
      optionSelected: option
    };
}
